import React from "react";
import styles from "./BtnOnMap.module.css";

interface BtnOnMapProps {
  id: string;
  text: string;
  icon: React.ReactNode;
  notification?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}


const BtnOnMap: React.FC<BtnOnMapProps> = ({ id, text, icon, notification, onClick }) => (
  <button className={styles["btn-on-map"]} id={id} onClick={onClick}>
    <span className={`${styles["btn-on-map-text"]} text-large`}>{text}</span>
    <span className={`${styles["btn-on-map-icon"]} text-large`}>
      <span id="message-notification-dot" className={`position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger p-1 ${notification ? "" : "d-none"}`}> </span>
      {icon}
    </span>
  </button>
);

export default BtnOnMap;